/**
 * Order item status options
 * Status flow for supplier picking: 0 (new) → 1 (picking) → 2 (picked) → 4 (sorted)
 * Status flow for stock items: 0 (new) → 3 (reserved) → 4 (sorted)
 */
export const ORDER_STATUS_OPTIONS = [
	{value: 'new', label: 'New', color: '#2196f3'},              // 0
	{value: 'picking', label: 'Picking', color: '#ff9800'},      // 1
	{value: 'picked', label: 'Picked', color: '#4caf50'},        // 2
	{value: 'reserved', label: 'Reserved', color: '#00bcd4'},    // 3
	{value: 'sorted', label: 'Sorted', color: '#9c27b0'},        // 4
	{value: 'cancelled', label: 'Cancelled', color: '#f44336'},  // 5
	{value: 'change_requested', label: 'Change Requested', color: '#ffc107'}, // 6
];

/**
 * Cancellation reason options
 */
export const CANCEL_REASONS = [
	'Out of stock',
	'Low quality',
	'Expiration date near',
	'Customer request',
];

/**
 * Get status color by status value
 */
export const getStatusColor = (status) => {
	const statusOption = ORDER_STATUS_OPTIONS.find((opt) => opt.value === status);
	return statusOption?.color || '#757575';
};
